import PropTypes, { shape, bool } from 'prop-types';

export const courseCatalogFeaturesShape = PropTypes.shape({
  searchbar: bool,
  titleOfCategory: bool,
  courseTypeFilter: bool,
});
